var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size-h2 text-footer px-4 my-5"},[_vm._v("REGISTRATION IS CURRENTLY NOT AVAILABLE.")])
}
var staticRenderFns = []

export { render, staticRenderFns }